const SHOW_OVERLAY_FLAG = 'SHOW_OVERLAY_FLAG';
const UNSAVED_CHANGES_FLAG = 'UNSAVED_CHANGES_FLAG';
const PHONE_RIGHT_PANEL_FLAG = 'PHONE_RIGHT_PANEL_FLAG';

export default {
    SHOW_OVERLAY_FLAG,
    UNSAVED_CHANGES_FLAG,
    PHONE_RIGHT_PANEL_FLAG,
};
